// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wopZV","newExpiryDate":"styles_newExpiryDate__3VPX1","footer":"styles_footer__om3MF"};